import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import MatchesCouponImpl from './matches-coupon.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * MatchesCoupon - render the content based on matches sport page for a specific filter.
 *
 * @class MatchesCoupon
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * MatchesCoupon prop types.
 *
 * @property {string} [eventGroupsId] - Event group id for the selected matches filter; when absent the view renders nothing.
 * @property {boolean} [isInPlayCoupon] - True when the selected filter is in-play, passed through to the events coupon as `isInPlay`.
 *
 * @memberof Mojito.Applications.Sports.Pages.MatchesCoupon
 */
const propTypes = {
    eventGroupsId: PropTypes.string,
    isInPlayCoupon: PropTypes.bool,
};

export default UIView('MatchesCoupon', MatchesCouponImpl, propTypes);
